export const pageDetails = {
  category: {
    cardImageLimit: 3,
  },
  subCategory: {
    cardImageLimit: 3,
  },
  product: {
    cardImageLimit: 1,
  },
  productDetails: {
    galleryImageLimit: 6,
  },
  homeCategory: {
    cardImageLimit: 1,
  },
  relatedProducts: {
    cardImageLimit: 1,
    productLimit: 6,
  },
};

export const getPageImageLimit = (pageName, settingName) => {
  const limit = pageDetails?.[pageName]?.[settingName];

  return Number.isInteger(limit) && limit > 0 ? limit : undefined;
};

export const getLimitedImages = (images = [], pageName, settingName) => {
  if (!Array.isArray(images)) {
    return [];
  }

  const limit = getPageImageLimit(pageName, settingName);

  return limit ? images.slice(0, limit) : images;
};
